export const QUOTE_TAGS = "catalyst.ui.quote.tags";
export const POLICY_FILTERS = "catalyst.ui.policy.filters";
